// Global constants for the whole app
import { ANALYTICS_ANONYMOUS_USER } from "@hex/common";
import {
  LDClient,
  LDContext,
  LDMultiKindContext,
  initialize,
} from "launchdarkly-js-client-sdk";

import hexLaunchDarklyProvider, {
  ALWAYS_RERENDER,
} from "./components/launchdarkly/hexLaunchDarklyProvider.js";
import { ORG_ID } from "./orgs.js";
import { launchDarklyClientId, launchDarklyDisabled } from "./util/data.js";

declare global {
  interface Window {
    launchDarklyContext?: LDContext;
    // LDFlagsState is only exported on node sdk
    launchDarklyFlagState?: object;
  }
}

const DEFAULT_CONTEXT: LDMultiKindContext = {
  kind: "multi",
  user: {
    key: ANALYTICS_ANONYMOUS_USER.id,
    name: ANALYTICS_ANONYMOUS_USER.name,
    email: ANALYTICS_ANONYMOUS_USER.email,
  },
  organization: {
    key: ORG_ID,
  },
};

const LD_CONTEXT = window.launchDarklyContext ?? DEFAULT_CONTEXT;
let LD_CLIENT: LDClient | undefined;

export function getLdClient(): LDClient | undefined {
  if (LD_CLIENT == null && !launchDarklyDisabled && launchDarklyClientId) {
    LD_CLIENT = initialize(launchDarklyClientId, LD_CONTEXT, {
      // we disable client side events since we were rely on our own `Feature Flag
      // Evaluated` event instead.
      sendEventsOnlyForVariation: false,
      bootstrap: window.launchDarklyFlagState,
    });

    if (window.launchDarklyFlagState == null) {
      window.launchDarklyFlagState = LD_CLIENT.allFlags();
    }
    if (window.launchDarklyContext == null) {
      window.launchDarklyContext = LD_CONTEXT;
    }
  }
  return LD_CLIENT;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export async function buildLaunchDarklyProvider(ldClient: LDClient) {
  return await hexLaunchDarklyProvider({
    // Force consumer to pass it in just to verify that it exists
    ldClient,
    timeout: 1,
    liveUpdateConfig: {
      "auto-refresh-client-config": {
        shouldRerender: ALWAYS_RERENDER,
      },
    },
  });
}
